<mat-toolbar class="bg-primary m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">Solicitar autorización</span>
    </mat-toolbar-row>
</mat-toolbar>

<div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <evk-solicitar-autorizacion-create-form [diligencia]="this.data.diligencia" [diligenciaConfig]="data.diligenciaConfig">
    </evk-solicitar-autorizacion-create-form>
    <div fxLayout="row" fxLayoutAlign="end end">
        <button mat-button (click)="dialogRef.close()">Cancelar</button>
        <button mat-raised-button type="button" color="accent" (click)="save()" [disabled]="!formValid">
            Enviar
        </button>
    </div>
</div>